export function Spinner({ className = 'size-4' }: { className?: string }) {
  return (
    <svg
      className={`animate-spin ${className}`}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.2" />
      <path
        d="M22 12a10 10 0 0 0-10-10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function FullPageSpinner({ label }: { label?: string }) {
  return (
    <div
      className="flex h-full min-h-screen flex-col items-center justify-center gap-3 bg-paper text-ink-3"
      role="status"
    >
      <Spinner className="size-6" />
      {label && <p className="text-xs">{label}</p>}
    </div>
  );
}

/** Table/list placeholder. Rows match the real row height to avoid a jump. */
export function SkeletonRows({ rows = 6, cols = 4 }: { rows?: number; cols?: number }) {
  return (
    <>
      {/* biome-ignore-start lint/suspicious/noArrayIndexKey: placeholder
          cells have no identity and never reorder — the index is the only
          key there is, and the only one that would be correct. */}
      {Array.from({ length: rows }).map((_, r) => (
        <tr key={r}>
          {Array.from({ length: cols }).map((__, c) => (
            <td key={c} className="border-b border-rule px-3 py-[0.625rem]">
              <div
                className="skeleton h-4"
                style={{ width: `${[70, 45, 55, 35, 60, 40][c % 6]}%` }}
              />
            </td>
          ))}
        </tr>
      ))}
      {/* biome-ignore-end lint/suspicious/noArrayIndexKey: see above */}
    </>
  );
}
